import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20Korean%20webtoon%20inspired%20background%20with%20sweeping%20ink%20brush%20strokes%20in%20warm%20coral%20pink%20and%20deep%20charcoal%20tones%2C%20dynamic%20flowing%20lines%20creating%20dramatic%20movement%2C%20soft%20gradient%20from%20warm%20peach%20to%20dark%20slate%2C%20modern%20artistic%20illustration%20style%2C%20dreamy%20atmospheric%20texture%2C%20suitable%20for%20hero%20background&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="在线漫画韩漫"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs md:text-sm font-medium mb-6">
          {t("hero.badge", "🔥 每日更新 200+ 话")}
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
          {t("hero.title_line1", "海量韩漫")}
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-rose-300 to-amber-300">
            {t("hero.title_line2", "免费畅读")}
          </span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-gray-200 max-w-2xl mx-auto leading-relaxed">
          {t("hero.subtitle")}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cta.start_reading")}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-white/50 text-white font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("nav.about")}
          </Link>
        </div>
      </div>
    </section>
  );
}